import { ticketSchema } from '@/ticket/api/types';
import { z } from 'zod';

type TicketCategories = z.infer<typeof ticketSchema.shape.category>;

export const TICKET_CATEGORY_DISPLAY_MAP: Record<TicketCategories, string> = {
  TODO: 'To Do',
  CHECK: 'Check',
  DEFECT: 'Defect',
  REPAIR: 'Repair',
  MISC: 'Miscellaneous',
};

type TicketStatus = z.infer<typeof ticketSchema.shape.status>;

interface TicketStatusDisplayConfig {
  label: string;
  color:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning';
}

export const TICKET_STATUS_DISPLAY_MAP: Record<
  TicketStatus,
  TicketStatusDisplayConfig
> = {
  OPEN: {
    label: 'Open',
    color: 'primary',
  },
  COMPLETED: {
    label: 'COMPLETED',
    color: 'success',
  },
  CLOSED: {
    label: 'Closed',
    color: 'error',
  },
};
